<template>
  <router-view />
</template>

<script>
import { cargarAvisoGlobal, obtenerAvisoGlobal } from "@/utils/aviso";

export default {
  name: "App",
  async mounted() {
    // Cargar el aviso global
    await cargarAvisoGlobal();

    const aviso = obtenerAvisoGlobal();
    if (aviso && aviso.activo) {
      let htmlContent = `<p>${aviso.valor}</p>`;
      if (aviso.imagen) {
        htmlContent += `<img src="${aviso.imagen}" style="max-width:100%; margin-top:10px;" />`;
      }

      Swal.fire({
        title: "Aviso del Sistema",
        html: htmlContent,
        icon: "info",
        confirmButtonText: "Aceptar",
      });
    }
  },
};
</script>

